import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const RetailSoftwareSystem = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Retail Software System" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-domains',
                            'text':'Business Domains'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Retail Software System</h2>
                        <h3>All In One</h3>
                        <p>Our retail management software would help you sell in store, online, at marketplaces, and on the go. You can manage all aspects of your business with this easy to use system. Add warehouses, outlets, new locations at the click of the button.</p>
                        <h3>Inventory Management</h3>
                        <p>Track inventory levels across multiple locations, create product variants, order directly with built in purchase orders, minimize out of stock using low stock alerts.</p>
                        <h3>Purchase Management</h3>
                        <p>Streamline processes right from purchase of inventory, assigning orders to suppliers, maintaining purchase bills, & so on.</p>
                        <h3>Fast, Secure, & Integrated</h3>
                        <p>Give your customers the flexibility they crave for. Accept payments of all kinds including contactless payments. Secured payments in line with PCI compliance along with end to end encryption</p>
                        <h3>Analytics</h3>
                        <p>Review business analytics i.e., sales, customer profiles, orders, and overall performance through central dashboard</p>
                        <h3>User Control</h3>
                        <p>Manage who gets access to which part of the data from the central dashboard. This provides users access only to the data that’s deemed necessary for their roles and prevent data breaches.</p>
                        <h3>We’ve got your back</h3>
                        <p>We offer comprehensive 24 X 7 support, through one on one training sessions, guides, videos, and webinars.</p>
                        <h3>Why Are We The Perfect Solution For Your Business?</h3>
                        <ul>
                            <li>Configured To Your Needs</li>
                            <li>Real Time</li>
                            <li>Scalable</li>
                            <li>Centralized Architecture</li>
                            <li>Integrated Analytics</li>
                            <li>Mobile Friendly</li>
                            <li>Offline Billing</li>
                        </ul>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default RetailSoftwareSystem;